import React from 'react';

import * as echarts from "echarts";

class LevelChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            
        }

    }

    componentDidMount() {
        this.initCharts()
    }

    // 第三步初始化
    initCharts = () => {
        const _this = this
        const {data} = this.props
        let myChart = echarts.init(document.getElementById( this.props.id + "_myChart"));
        let option = {
            tooltip: {
                trigger: 'item'
              },
              legend: {
                bottom: '5%',
                left: '20%'
              },
              series: [
                {
                  name: 'Access From',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  label: {
                    show: true,
                    position: 'center',
                    formatter: '{c}',
                    fontSize:'28'
                  },
                  center:['30%','50%'],
                  labelLine: {
                    show: false
                  },
                  data: data.data
                }
              ]
        }

        myChart.setOption(option);
        window.addEventListener("resize", function () {
            myChart.resize();
        });
    }

    render() {
        const { id } = this.props;
        return (
            <div id={id + '_myChart'} style={{ width: "350px", height: "250px" }}>

            </div>
        )
    }
}

export default LevelChart